import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const ServiceTypes = ({
  updatedServices,
  selectedService,
  setSelectedService,
  navigate,
  handleServiceClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="widget departments-list"
      style={{ backgroundColor: "var(--color-fourth)" }}
    >
      <h3 className="widget-title">{t("servicesPage.serviceTypes")}</h3>
      <div className="row justify-content-center service-loop">
        <ul>
          {updatedServices.length === 0 ? (
            <div>
              <CircularProgress size={24} />
            </div>
          ) : (
            updatedServices.map((service, index) => (
              <div key={index} style={{ textAlign: "start" }}>
                <li>
                  <Link
                    onClick={() => {
                      setSelectedService(service);
                      navigate("/service-details", { state: { service } });
                      console.log("SERVIERS", service, selectedService);
                      handleServiceClick(service);
                    }}
                    style={{
                      color:
                        selectedService?.sortOrder === service.sortOrder
                          ? "var(--color-doctor)"
                          : "white",
                    }}
                  >
                    <MdOutlineArrowRightAlt style={{ marginRight: "10px" }} />
                    {t(
                      `servicesPage.service${service.sortOrder}.${service?.title}`
                    )}
                  </Link>
                </li>
              </div>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default ServiceTypes;
